import React from "react";
import Field from "./Field";
import TextInput from "../atoms/TextInput";

// Molecule: Field (text) — variants text / email / tel via the `type` prop.
// `inputClassName` lets a caller reuse the select control's styling for a
// text control (the Province field does this) without a new component.
const TextField = ({
    label,
    name,
    id,
    type = "text",
    value,
    onChange,
    placeholder,
    required = false,
    error,
    inputClassName = "smww-input",
}) => {
    const controlId = id || name;
    return (
        <Field label={label} htmlFor={controlId} required={required} error={error}>
            <TextInput
                id={controlId}
                name={name}
                type={type}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                className={inputClassName}
            />
        </Field>
    );
};

export default TextField;
